/* ============================================
   AANYA Recently Viewed Products Tracker
   Stores product handles in localStorage
   ============================================ */

(function() {
  'use strict';

  var MAX_ITEMS = 8;
  var STORAGE_KEY = 'aanya_recently_viewed';

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveRecentlyViewed(products) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (e) {}
  }

  function trackProduct() {
    var productHandle = document.querySelector('[data-product-handle]');
    if (!productHandle) return;

    var handle = productHandle.dataset.productHandle;
    var title = productHandle.dataset.productTitle || '';
    var image = productHandle.dataset.productImage || '';
    var price = productHandle.dataset.productPrice || '';
    var url = productHandle.dataset.productUrl || '';

    if (!handle) return;

    var products = getRecentlyViewed();

    products = products.filter(function(p) { return p.handle !== handle; });

    products.unshift({
      handle: handle,
      title: title,
      image: image,
      price: price,
      url: url
    });

    if (products.length > MAX_ITEMS) {
      products = products.slice(0, MAX_ITEMS);
    }

    saveRecentlyViewed(products);
  }

  document.addEventListener('DOMContentLoaded', trackProduct);
})();
